<div class="wrapper pt">
  <div class="container pb centered">
    <h1>Page not found</h1>
  </div>
  <route-footer></route-footer>
</div>
